import React, { useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Button, Typography } from "@mui/material";
import {
  CancelButton,
  RejectButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { useDispatch, useSelector } from "react-redux";
import {
  excludeUser,
  getAllEvaluationcycle,
  getCycleAssignedUsers,
} from "../../../../../redux/features/appraisalSlice";
import { useSnackbar } from "notistack";

const ExcludeUser = ({
  ids,
  setSelectedUserIds,
  cycleId,
  setUpdateValidation,
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const { loading } = useSelector((state) => state.appraisal);

  const handleExclude = () => {
    const data = { ids: [...ids] };
    dispatch(excludeUser(data)).then((res) => {
      if (res.payload.status === "failed") {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      } else if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        setOpen(false);
        setSelectedUserIds([]);
        dispatch(getCycleAssignedUsers(cycleId));
        setUpdateValidation(true);
      }
    });
  };

  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={"Exclude User"}
      closeButton={true}
      fullWidth
      maxWidth={"xs"}
      popupButton={
        <Button
          color="error"
          size="small"
          variant="outlined"
          sx={{ borderRadius: 3 }}
          onClick={() => setOpen(true)}
        >
          Exclude User
        </Button>
      }
      content={
        <Box>
          <Typography>Are you sure ? you want to exclude...!</Typography>
        </Box>
      }
      actionButton={
        <>
          <CancelButton size={"small"} action={() => setOpen(false)}>
            Cancel
          </CancelButton>
          <RejectButton
            disabled={loading}
            action={handleExclude}
            size={"small"}
          >
            {loading ? "Please Wait..." : "Exclude"}
          </RejectButton>
        </>
      }
    />
  );
};

export default ExcludeUser;
